import {
  PAGES,
  routeToBilling,
  routeToHiringEvents,
  routeToHubs,
  routeToSettings,
  routeToUserRoles,
  routeToDashboard,
  routeToManageBudgets,
  routeToJobReporting,
} from '../../redux/nodes/router/actions';

const NAV_ONE_LINE_HEIGHT = 75;
const NAV_TWO_LINE_HEIGHT = 105;

const TRANSITION_DELAY = 0.3;

const NAME_TO_ROUTE_MAP = {
  show_hiring_events: routeToHiringEvents,
  show_user_roles_permissions: routeToUserRoles,
  show_hubs: routeToHubs,
  show_settings: routeToSettings,
  show_billing: routeToBilling,
  show_dashboard: routeToDashboard,
  show_manage_budgets: routeToManageBudgets,
  show_job_reporting: routeToJobReporting,
};

const ROUTE_TO_KEY_MAP = {
  [PAGES.ACCOUNT_DASHBOARD]: 'show_account_dashboard',
  [PAGES.BRAND_BOOST]: 'show_brand_boost',
  [PAGES.HIRING_EVENTS]: 'show_hiring_events',
  [PAGES.MARKET_INTELLIGENCE]: 'show_market_intelligence',
  [PAGES.REPORTING]: 'show_reporting',
  [PAGES.USER_ROLES]: 'show_user_roles_permissions',
  [PAGES.SETTINGS]: 'show_settings',
  [PAGES.SUB_ORGANIZATIONS]: 'show_settings',
  [PAGES.HUBS]: 'show_hubs',
  [PAGES.BILLING]: 'show_billing',
  [PAGES.BILLING_CARD]: 'show_billing',
  [PAGES.DASHBOARD]: 'show_dashboard',
  [PAGES.MANAGE_BUDGETS]: 'show_manage_budgets',
  [PAGES.JOB_REPORTING]: 'show_job_reporting',
};

// ID is the same for both staging and production environment.
const ALL_EMPLOYERS_ID = 'c4fae913-6cbb-476c-9931-a21f10b2c2d2';

const JOBCASE_EMPLOYER_ID = '0d8cdc2d-25ee-4390-abbf-a01c74323dde';

export {
  NAV_ONE_LINE_HEIGHT,
  NAV_TWO_LINE_HEIGHT,
  NAME_TO_ROUTE_MAP,
  ROUTE_TO_KEY_MAP,
  TRANSITION_DELAY,
  ALL_EMPLOYERS_ID,
  JOBCASE_EMPLOYER_ID,
};

export default {
  NAV_ONE_LINE_HEIGHT,
  NAV_TWO_LINE_HEIGHT,
  NAME_TO_ROUTE_MAP,
  ROUTE_TO_KEY_MAP,
  TRANSITION_DELAY,
  ALL_EMPLOYERS_ID,
  JOBCASE_EMPLOYER_ID,
};
